<div layout margin-top-small-x>
  <div
    *ngFor="let holder of placeholders; index as i; trackBy: trackByIndex"
    [class.error]="error"
    class="wrap"
  >
    <input
      #input
      (click)="onClick(i)"
      (input)="onInput($event, i)"
      (paste)="onPaste($event, i)"
      (keydown)="onKeydown($event, i)"
      type="number"
      autocomplete="one-time-code"
    />
  </div>
</div>

<div *ngIf="error" class="errorMsg" margin-top-small-x>
  {{ error.error[0] }}
</div>
